/**
 * Feaststar tiny logger.
 *
 * In development, forwards to console. In production, becomes a no-op
 * so we don't leak internals or spam the browser console — but we can
 * still route to Sentry/PostHog etc. later by editing this one file.
 *
 * NOTE: this is the SINGLE, INTENTIONAL location in the codebase where
 * `console.*` may be used. All calls are guarded by `isDev` so nothing
 * ever reaches the browser console in production builds. Any other
 * `console.*` call in the repo is a bug.
 */
const isDev = process.env.NODE_ENV === "development";

export const logger = {
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    if (isDev) console.error(...args);
    // TODO: forward to Sentry in production when integrated
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
};
